import bookStudio from '../assets/images/BookStudio.jpeg'
import masterClass from '../assets/images/MasterClass.jpeg'
import miniMasterClass from '../assets/images/MiniMasterClass.jpeg'
import tuition from '../assets/images/Tuition.jpeg'

export const _MUSIC_STUDIO_CONTENT = {
    bts: {
        title: 'Book the Studio',
        description: 'Our music studio is an industry standard, professional recording studio that can be booked with our engineer or as a dry hire. We are fully set up to record music or podcasts. Please use the link to enquire about a booking.',
        gallery: [
            {
                default: bookStudio,
                list: [
                    { media: '(max-width: 768px)', srcset: bookStudio },
                    { media: '(min-width: 769px)', srcset: bookStudio }
                ]
            }
        ]
    },
    mc: {
        title: 'Masterclass',
        description: 'Our music production masterclass is designed and run by our Abbey Road trained engineer. It is aimed at young people aged 14 - 17, of all abilities, who would like to learn more about professional music production techniques and how to use the #Merky FC Studio. Please see our brochure for more info or book a place on one of the courses via the link.',
        gallery: [
            {
                default: masterClass,
                list: [
                    { media: '(max-width: 768px)', srcset: masterClass },
                    { media: '(min-width: 769px)', srcset: masterClass }
                ]
            }
        ]
    },
    mmc: {
        title: 'Mini Masterclass',
        description: 'Our mini masterclasses are smaller, more condensed versions of the main music production masterclass, but also include a podcasting option. Please see the brochure for more info and book via the link.',
        gallery: [
            {
                default: miniMasterClass,
                list: [
                    { media: '(max-width: 768px)', srcset: miniMasterClass },
                    { media: '(min-width: 769px)', srcset: miniMasterClass }
                ]
            }
        ]
    },
    t1to1: {
        title: '1:1 Tuition',
        description: 'For those that would like a more bespoke approach to music production education and advancement, our engineer Matt is available for 1:1 teaching sessions. We can cover whatever you like! Just enquire via the link below.',
        gallery: [
            {
                default: tuition,
                list: [
                    { media: '(max-width: 768px)', srcset: tuition },
                    { media: '(min-width: 769px)', srcset: tuition }
                ]
            }
        ]
    },
};